module.exports = __webpack_public_path__ + "static/nature-ie-48201ead699a96429e969b7d7a62371a.png";